'use client';

import type { Zero } from '@rocicorp/zero';
import { useZero } from '@rocicorp/zero/react';
import type { schema } from '../zero-schema';
import type { clientMutators } from './client-mutators';

/** The Zero client `ZeroClientProvider` builds: app schema plus client mutators. */
export type AppZero = Zero<typeof schema, typeof clientMutators>;

/**
 * `useZero()` typed with the app schema and the client mutators, so every
 * `zero.mutate.<namespace>.<name>(args)` call is checked against
 * mutator-types.ts. Must run under `ZeroClientProvider`.
 */
export function useAppZero(): AppZero {
  return useZero<typeof schema, typeof clientMutators>();
}
